// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylesheets/functions.css
// module id = 4
// module chunks = 0